"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddFreeShippingOfferErrorResponse = exports.Name = exports.AddFreeShippingOfferFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'add-free-shipping-offer-failed';
const AddFreeShippingOfferFailedEvent = exports.AddFreeShippingOfferFailedEvent = Name;
const isAddFreeShippingOfferErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAddFreeShippingOfferErrorResponse = isAddFreeShippingOfferErrorResponse;
//# sourceMappingURL=index.js.map